import {
  Component,
  Input,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TotalCount } from '../search.interface';
import { FILTER_SECTION } from '../search.component';

@Component({
  selector: 'ft-search-results-literature',
  templateUrl: './search-results-literature.component.html',
  styleUrls: ['./search-results-literature.component.scss'],
})
export class SearchResultsLiteratureComponent implements OnInit {
  @Input() results: [];
  @Input() totalCount: TotalCount["literature"];
  @Input() valueToShow: number;
  @Input() isViewAll: boolean;
  @Output()
  viewAllClick: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  loadMoreForms: EventEmitter<object> = new EventEmitter<object>();
  queryParams: Params;

  constructor(private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.queryParams = this.activatedRoute.snapshot.queryParams;
  }

  loadMore(event): void {
    this.loadMoreForms.emit({event, type: 'literature'});
  }

  clickEvent(event): void {
    this.isViewAll = true;
    this.viewAllClick.emit(FILTER_SECTION.literatureFilterSection);
  }
}
